import classNames from "classnames";
import { useLayout, useTranslations } from "providers";

export const HelpButton: React.FC = () => {
  const { isFooterVisible: isOpen, setIsFooterVisible: setIsOpen } = useLayout();

  const i18n = useTranslations();

  const buttonId = "helpMenuButton";
  const buttonClass = classNames("nav-link");

  return (
    <div className="sbb-header-nav-item">
      <a className={buttonClass} id={buttonId} onClick={() => setIsOpen(!isOpen)}>
        <div className="sbb-header-nav-item-icon me-2 ">
          <i className="ms-Icon ms-Icon--Help" />
        </div>
        <span className="hide-on-mobile">{i18n.Help}</span>
      </a>
    </div>
  );
};
